import React from 'react';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import Header from 'components/Header';
import Footer from 'components/Footer';
// import Intercom from 'components/Intercom'
// import Zopim from 'components/Zopim'
// import GoogleTagManager from 'components/GoogleTagManager';

import { Modal, Form, Button, Dropdown, Message } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import { promptOneTap } from 'lib/socialAuthHandler';

import USER_QUERY from './graphql/userQuery.gql';
import WhatsApp from '../WhatsApp';

const MainLayout = (Component) => {
  class Layout extends React.Component {
    state = {
      country_id: 1,
      newMember: false,
      modal_errors: [],
      loading: false,
      guestMutated: false,
    };

    componentDidMount() {
      window.localStorage.setItem('page-has-been-force-refreshed', 'false');

      setTimeout(() => {
        promptOneTap();
      }, 5000);

      // getting UTM parameters and saving them to users local storage
      if (location.search.includes('utm')) {
        // const UTMS = queryString.parse(location.search);
        // this.setState({ utms: UTMS });
        if (
          !localStorage.latestUTM ||
          localStorage.latestUTM !== location.search
        ) {
          localStorage.setItem('latestUtm', location.search);
        }
      }

      // if (
      //   process.env.NODE_ENV === 'production' &&
      //   !!this.props.userQuery &&
      //   !!this.props.userQuery.user &&
      //   !!this.props.userQuery.user.email
      // ) {
      //   window.fbq('init', '1549607158701260', {
      //     em: this.props.userQuery.user.email,
      //     country: this.props.userQuery.user.country.iso_code.toLowerCase(),
      //   });
      //   // gtag('event', 'page_view', {
      //   //   send_to: 'AW-864689100',
      //   //   user_id:
      //   //     !!this.props.userQuery &&
      //   //     !!this.props.userQuery.user &&
      //   //     this.props.userQuery.user.id,
      //   // });
      // }

      if (sessionStorage.getItem('campaignId') === 'signup100') {
        sessionStorage.removeItem('campaignId');
      }
    }

    componentWillReceiveProps(nextProps) {
      const { userQuery } = nextProps;
      const { user = {} } = userQuery;

      // eslint-disable-next-line no-console
      console.rollbar.configure({
        payload: {
          person: {
            id: user.id,
            email: user.email,
          },
          currentUser: user,
        },
      });

      this.setState({ newMember: nextProps.firstSignup.isNewMember });

      // Redirect if reseller to business website
      // if (
      //   !!nextProps.userQuery &&
      //   !!nextProps.userQuery.user &&
      //   nextProps.userQuery.user.is_reseller
      // ) {
      //   window.location = 'https://business.lynks.com';
      // }
    }

    notify = () => toast.error('Wow so easy !');

    _confirm = async () => {
      try {
        this.setState({ modal_errors: [] });
        this.setState({ loading: true });
        const result = await this.props.updateAuthUser({
          variables: {
            country_id: this.state.country_id,
          },
        });
        if (result.data.UpdateAuthUser.id) {
          this.props.updateFirstSignup({
            variables: {
              isNewMember: false,
            },
          });
          this.setState({
            newMember: false,
          });
        }
      } catch (e) {
        // console.log(e)
        this.state.modal_errors.push(e.message);
      }
      this.setState({ loading: false });
    };

    render() {
      const isAr = this.props.intl.locale === 'ar';
      const { wrappedComponentRef, userQuery, ...remainingProps } = this.props;
      const currentUser = userQuery && userQuery.user ? userQuery.user : false;
      const countryOptions = [
        { key: 'eg', value: 1, text: 'Egypt' },
        { key: 'ksa', value: 421, text: 'Saudi Arabia' },
        { key: 'uae', value: 461, text: 'United Arab Emirates' },
      ];

      const title = isAr
        ? 'اشتري اونلاين من أفضل متاجر امريكا واستلم في مصر | لينكس'
        : 'Buy online from the best US, UK & UAE stores | Lynks';

      const description = isAr
        ? 'اشتري اونلاين من أشهر وأفضل المتاجر في امريكا أو إنجلترا و وفر في الشحن الدولي مع لينكس.'
        : 'Shop from the best online stores in USA or UK and save on international shipping with Lynks.';

      const img = isAr
        ? 'https://storage.googleapis.com/lynks-assets/og/og-img-ar.png'
        : 'https://storage.googleapis.com/lynks-assets/og/og-img-en.png';

      return (
        <div dir={isAr ? 'rtl' : 'ltr'} lang={this.props.intl.locale}>
          <Helmet
            titleTemplate={isAr ? 'لينكس | %s' : '%s | Lynks'}
            defaultTitle={title}
          >
            <meta name="description" content={description} />

            <meta property="og:url" content="https://www.lynks.com" />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={img} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta property="twitter:domain" content="lynks.com" />
            <meta property="twitter:url" content="https://www.lynks.com" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={img} />
          </Helmet>

          <Header
            currentUser={currentUser}
            geo={this.props.geo}
            {...remainingProps}
          >
            <Component
              currentUser={currentUser}
              {...remainingProps}
              ref={wrappedComponentRef}
            />

            <Footer currentUser={currentUser} {...remainingProps} />
          </Header>
          <WhatsApp style={{ position: 'fixed' }} />

          <Modal
            closeIcon
            dimmer={this.state.newMember}
            open={this.state.newMember}
          >
            <Modal.Content>
              <Message
                hidden={this.state.modal_errors < 1}
                error
                list={this.state.modal_errors}
              />

              <Form>
                <Form.Field>
                  <label htmlFor="presentation">Country</label>
                  <Dropdown
                    placeholder="Select Country"
                    fluid
                    search
                    selection
                    options={countryOptions}
                    value={this.state.country_id}
                    onChange={(e, data) =>
                      this.setState({ country_id: data.value })
                    }
                  />
                </Form.Field>
              </Form>
            </Modal.Content>
            <Modal.Actions>
              <Button
                loading={this.state.loading}
                positive
                icon="checkmark"
                labelPosition="right"
                content="Confirm"
                onClick={this._confirm}
              />
            </Modal.Actions>
          </Modal>

          <ToastContainer position="bottom-center" />
        </div>
      );
    }
  }

  const IS_TOKEN = gql`
    query IsToken {
      isToken
    }
  `;
  const IS_LOGGED_IN = gql`
    query IsLoggedIn {
      isLoggedIn
    }
  `;

  const GEO = gql`
    query Geo {
      geo @client {
        countryCode
      }
    }
  `;
  const GUEST = gql`
    mutation guest {
      guest {
        token
      }
    }
  `;

  const UPDATE_GEO = gql`
    mutation updateGeo($countryCode: String!) {
      updateGeo(countryCode: $countryCode) @client
    }
  `;

  const FIRST_SIGNUP = gql`
    query firstSignup {
      firstSignup @client {
        isNewMember
      }
    }
  `;

  const UPDATE_FIRST_SIGNUP = gql`
    mutation updateFirstSignup($isNewMember: Boolean!) {
      updateFirstSignup(isNewMember: $isNewMember) @client
    }
  `;

  const UPDATE_AUTH_USER = gql`
    mutation UpdateAuthUser($country_id: ID!) {
      UpdateAuthUser(country_id: $country_id) {
        id
      }
    }
  `;

  return compose(
    injectIntl,
    // withRouter,
    graphql(IS_TOKEN, {
      options: { fetchPolicy: 'cache-only' },
      props: ({ data: { isToken } }) => ({
        isToken,
      }),
    }),
    graphql(IS_LOGGED_IN, {
      options: { fetchPolicy: 'cache-only' },
      props: ({ data: { isLoggedIn } }) => ({
        isLoggedIn,
      }),
    }),
    graphql(GUEST, {
      name: 'guest',
      options: () => ({
        errorPolicy: 'all',
        onError: () => null,
      }),
    }),
    graphql(FIRST_SIGNUP, {
      options: { fetchPolicy: 'cache-only' },
      props: ({ data: { firstSignup } }) => ({
        firstSignup,
      }),
    }),
    graphql(GEO, {
      options: { fetchPolicy: 'cache-only' },
      props: ({ data: { geo } }) => ({
        geo,
      }),
    }),
    graphql(UPDATE_GEO, { name: 'updateGeo' }),
    graphql(UPDATE_FIRST_SIGNUP, { name: 'updateFirstSignup' }),
    graphql(USER_QUERY, {
      name: 'userQuery',
      skip: (ownProps) => !ownProps.isToken,
    }),
    graphql(UPDATE_AUTH_USER, { name: 'updateAuthUser' })
  )(Layout);
};

export default MainLayout;



// WEBPACK FOOTER //
// ./app/components/MainLayout/index.js